require('./showHistoryDialog.less');


class ShowHistoryController {
    activeLine;
    activeMonth;
    forecastHistory;


    tableDefinition = {
        settings: {hideToolbar: true, hidePaginator: true, promise: null, initialOrderBy: '-createdTime'},
        columns:[
            {title:'Tidspunkt', name: 'createdTime', type:'date', dateFormat: 'dd.MM.yyyy - HH:mm'},
            {title:'Dag', name: 'day'},
            {title:'Verdi (før)', name:'oldValue', type:'number'},
            {title:'Verdi (etter)', name:'newValue', type:'number'},
            {title:'Utført av', name:'userName'}
        ]
    };

    constructor(private $mdDialog, private toastService, private ForecastHistory){
    }

    $onInit(){
        this.tableDefinition.settings.promise = this.ForecastHistory.getForecastHistory({lineId: this.activeLine.forecastLine.id, month: this.activeMonth}).$promise.then((result) => {
            this.forecastHistory = result.map(x => {
                x.userName = x.user.name;
                x.createdTime = new Date(x.createdTime);
                return x;
            });
        }, (error) => {
            this.toastService.parseError(error);
        })
    };


    save (){    };

    hide () {
        this.$mdDialog.hide();
    };
    cancel () {
        this.$mdDialog.cancel();
    };

}


class ShowHistoryOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "showHistoryDialogController";
    public template: any = require('./showHistoryDialog.html');
    bindings: any = {
        activeLine:'=',
        activeMonth:'='
    };

}


rkcApp.controller("showHistoryDialogController", ['$mdDialog', 'toastService', 'ForecastHistory', function ($mdDialog, toastService, ForecastHistory) {
    return new ShowHistoryController($mdDialog, toastService, ForecastHistory);
}])
    .component("showHistoryDialog", new ShowHistoryOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/prognosis/showHistoryDialog/showHistoryDialog.ts
 **/